import jobServices from 'ApiService/Placement/jobServices';
import Card from 'components/card';
import Modal from 'pages/Student/Assignment/UploadAssignment/Steps/Model';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsXCircleFill } from 'react-icons/bs';

const Attachments = ({ selectedStudent }) => {
  const [existingFiles, setExistingFiles] = useState([]);
  const [modalFile, setModalFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const BASE_URL = `${process.env.REACT_APP_API_BASE_URL.replace(
    '/api/v1',
    ''
  )}`;

  const handleRemoveExistingFile = async (fileId) => {
    try {
      const response = await jobServices.deleteAttachment(
        fileId,
        selectedStudent._id
      );
      if (response.data.success) {
        setExistingFiles(existingFiles.filter((file) => file._id !== fileId));
        toast.success('File deleted successfully');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('Failed to delete file');
    }
  };

  const handleFileClick = (file) => {
    const fileUrl = `${BASE_URL}/${file.filepath}`;
    const fileType = file.fileType.toLowerCase();
    let type = 'other';

    if (['jpg', 'jpeg', 'png'].includes(fileType)) {
      type = 'image';
    } else if (fileType === 'pdf') {
      type = 'pdf';
    } else if (['mp4', 'webm'].includes(fileType)) {
      type = 'video';
    }

    setModalFile({
      src: fileUrl,
      type,
    });
    setIsModalOpen(true);
  };

  const fetchExistingFiles = async () => {
    try {
      const response = await jobServices.getAttachments(selectedStudent._id);
      if (response.data.success) {
        setExistingFiles(response.data.data || []);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch attachments.'
      );
    }
  };

  useEffect(() => {
    if (selectedStudent?._id) {
      fetchExistingFiles();
    }
  }, [selectedStudent._id]);

  const renderExistingFilePreview = (file) => {
    const isImage = ['jpg', 'jpeg', 'png'].includes(
      file.fileType.toLowerCase()
    );
    const fileUrl = `${BASE_URL}/${file.filepath}`;

    return (
      <div
        key={file._id}
        className="relative flex h-[350px] flex-col justify-between rounded-lg border bg-white p-4 shadow-md dark:bg-navy-800"
      >
        <div className="cursor-pointer" onClick={() => handleFileClick(file)}>
          {isImage ? (
            <img
              src={fileUrl}
              alt={file.filename}
              className="h-[200px] w-full rounded-lg object-cover"
            />
          ) : (
            <div className="flex h-[200px] w-full items-center justify-center rounded-lg bg-gray-200 text-gray-600 dark:bg-navy-700 dark:text-gray-300">
              <span className="text-sm font-medium">
                {file.fileType.toUpperCase()}
              </span>
            </div>
          )}
          <div className="mt-3">
            <p className="text-center font-medium text-gray-800 dark:text-white">
              {file.filename}
            </p>
            <p className="text-center text-sm text-gray-500 dark:text-gray-400">
              Uploaded: {new Date(file.submittedOn).toLocaleDateString()}
            </p>
          </div>
        </div>
        <button
          onClick={() => handleRemoveExistingFile(file._id)}
          className="absolute right-2 top-2 ml-2 flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-white hover:bg-red-700"
        >
          <AiOutlineDelete size={16} />
        </button>
      </div>
    );
  };

  return (
    <div className="mt-6 h-full w-full px-4 md:px-8">
      <Card extra="w-full mx-auto pb-6">
        <div className="rounded-lg px-6 pt-6">
          <h5 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
            Existing Files
          </h5>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {existingFiles.length > 0 ? (
              existingFiles.map((file) => renderExistingFilePreview(file))
            ) : (
              <p className="col-span-full text-center text-gray-500">
                No existing files
              </p>
            )}
          </div>
        </div>
      </Card>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        file={modalFile}
      />
    </div>
  );
};

export default Attachments;
